import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export default function useDeleteAccount(): any {
  const [loading, setLoading] = useState(false);

  async function sendEmail(email: string): Promise<any> {
    setLoading(true);
    try {
      const { status, data } = await api.post(`v1/drivers/send-email`, {
        email,
      });

      if (status === 201) {
        toast.success(
          'Solicitação enviada. Você receberá um e-mail de confirmação.',
        );
        return { status, data };
      }
    } catch (error) {
      toast.error(
        'Solicitação não enviada. Verifique suas informações e tente novamente.',
      );
    } finally {
      setLoading(false);
    }
  }

  return { sendEmail, loading };
}
